const mediaHost = process.env.RAZZLE_MEDIA_HOST;

export const getSrc = (file, filter, error = false) => {
  // Return the original file when it's either an SVG, or the `original` filter is passed.
  if (file.indexOf('.svg') !== -1 || filter === 'original') {
    return `https://${mediaHost}/originals/${file}`;
  }

  if (!error) {
    // If no error occurred yet, return the cached path
    return `https://${mediaHost}/cache/${filter}/${file}`;
  }

  // When the cached path is unavailable, return the resolve path, which on it's turn
  // caches the image for next time.
  return `${process.env.RAZZLE_API_BASE_URL}/media/cache/resolve/${filter}/${file}`;
};

export const backgroundImage = (file, filter, options = '') => `url('${getSrc(file, filter)}') ${options}, url('${getSrc(file, filter, true)}') ${options}`;
